module.exports = __webpack_public_path__ + "assets/img/22-s.f182e31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/22-s.jpg
// module id = kINZ
// module chunks = 0